"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.XML_CHARKEY = exports.XML_ATTRKEY = void 0;
/**
 * Default key used to access the XML attributes.
 */
exports.XML_ATTRKEY = "$";
/**
 * Default key used to access the XML value content.
 */
exports.XML_CHARKEY = "_";
//# sourceMappingURL=interfaces.js.map